/** Today as YYYY-MM-DD in the user's local time. */
export function todayISO(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function parseLocal(iso: string): Date {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
}

/** Whole calendar days from `from` to `to` (both YYYY-MM-DD). */
export function calendarDaysBetween(from: string, to: string): number {
  const ms = parseLocal(to).getTime() - parseLocal(from).getTime();
  return Math.max(0, Math.round(ms / 86_400_000));
}

/** Mon–Fri days elapsed from `from` up to (not including) `to`. Holidays are not considered. */
export function businessDaysBetween(from: string, to: string): number {
  const cur = parseLocal(from);
  const end = parseLocal(to);
  let count = 0;
  while (cur < end) {
    const dow = cur.getDay();
    if (dow !== 0 && dow !== 6) count++;
    cur.setDate(cur.getDate() + 1);
  }
  return count;
}

/** True when `dateStr` (YYYY-MM-DD, or any ISO timestamp) falls within the last `days` days. */
export function isWithinLastDays(dateStr: string | null | undefined, days: number): boolean {
  if (!dateStr) return false;
  return calendarDaysBetween(dateStr, todayISO()) <= days;
}
